import { styled as o } from "styled-components";
import { Colors as r } from "../../../../styles/colors/index.js";
import { Small as m } from "../../../../styles/typography/index.js";
const t = o.span`
  color: rgb(${r.Gray});
  word-break: keep-all;
  white-space: nowrap;
  ${m}
`;
export {
  t as Timestamp
};
